import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { HTML_LINK_TARGET } from '../../../constants/html'
import { ROUTE_PATH_LIST_AUTH } from '../../../constants/route'
import { usePageBrowserTabTitle } from '../../../hooks'
import { getAppVersion, loadAppVersion } from '../../../utils/appVersion'
import { getQaSelector } from '../../../utils/common'
import { Link } from '../../Link'
import { AuthFooter } from '../AuthFooter'
import { AuthFormWrapper } from '../AuthFormWrapper'
import { AuthHeader } from '../AuthHeader'
import { AuthHelpText } from '../AuthHelpText'
import { AuthLayout } from '../AuthLayout'
import { AuthPanel } from '../AuthPanel'
import { AuthTitle } from '../AuthTitle'

import {
  AUTH_ABOUT_OPEN_SOURCE_LICENSES_LINK,
  QA_NAME_AUTH_ABOUT_OPEN_SOURCE_LICENSES_LINK,
  QA_NAME_AUTH_ABOUT_SIGN_IN_LINK,
} from './AuthAbout.constants'
import { AuthAboutManufacturer } from './AuthAboutManufacturer'

import * as styles from './AuthAbout.module.css'

function AuthAbout() {
  const { t } = useTranslation()

  const [version, setVersion] = useState(getAppVersion)

  usePageBrowserTabTitle({ pageTitle: t('BrowserTab.AboutPageTitleKey') })

  useEffect(() => {
    loadAppVersion().then(setVersion)
  }, [])

  const qaProps = getQaSelector({
    value: QA_NAME_AUTH_ABOUT_OPEN_SOURCE_LICENSES_LINK,
  })

  return (
    <AuthLayout>
      <AuthPanel>
        <AuthHeader
          description={t('Auth.SignInDescriptionKey')}
          link={{
            qaName: QA_NAME_AUTH_ABOUT_SIGN_IN_LINK,
            text: t('Auth.SignInLinkKey'),
            to: ROUTE_PATH_LIST_AUTH.login(),
          }}
        />
        <AuthFormWrapper>
          <AuthTitle className={styles.title} title={t('Auth.AboutTitleKey')} />
          <AuthAboutManufacturer />
          <AuthHelpText
            className={styles.helpText}
            text={t('Auth.AboutTextKey')}
          />
          <Link
            {...qaProps}
            className={styles.link}
            rel='noopener noreferrer'
            target={HTML_LINK_TARGET.blank}
            to={AUTH_ABOUT_OPEN_SOURCE_LICENSES_LINK}
          >
            {t('Auth.OpenSourceLicensesLinkKey')}
          </Link>
          {version ? (
            <p className={styles.version}>
              {t('Auth.AboutVersionKey', { version })}
            </p>
          ) : null}
        </AuthFormWrapper>
        <AuthFooter />
      </AuthPanel>
    </AuthLayout>
  )
}

export default AuthAbout
